import React from 'react';
import { 
  Card, CardHeader, CardContent, CardActions, 
  Typography, Divider, Stack, Box, Button 
} from '@mui/material';
import InfoIcon from '@mui/icons-material/Info';

const ModelInfoCard = ({ 
  title, 
  subtitle, 
  data = {}, 
  onClose, 
  icon = <InfoIcon color="primary" /> 
}) => {
  return (
    <Card sx={{width:"100%", maxWidth: 320, boxShadow: 3, borderRadius: 2, margin:2,
    position: 'fixed',
    bottom: 10,
    // left: 0,
    // width: '380px',
    height: '75vh',
    backgroundColor: 'rgba(214, 233, 245, 0.9)', // Semi-transparent black
    // display: 'flex',
    // justifyContent: 'center',
    // alignItems: 'center',
    zIndex: 99999, // High number to stay on top
    }}    
    >
      <CardHeader
        avatar={icon}
        title={<Typography variant="h6">{title}</Typography>}
        subheader={subtitle}
      />
      <Divider />
      
      <CardContent>
        <Stack spacing={1.5}>
          {/* Loop through data object to display labels and values */}
          {Object.entries(data).map(([key, value]) => (
            <Box key={key} sx={{ display: 'flex', justifyContent: 'space-between' }}>
              <Typography variant="body2" color="text.secondary" sx={{ fontWeight: 'bold', textTransform: 'capitalize' }}>
                {key.replace(/([A-Z])/g, ' $1')}:
              </Typography>
              <Typography variant="body2">
                {value || 'N/A'}
              </Typography>
            </Box>
          ))}
        </Stack>
      </CardContent>

      {onClose && (
        <>
          {/* <Divider /> */}
          <CardActions sx={{ justifyContent: 'flex-end', p: 2 }}>
            <Button size="small" variant="outlined" onClick={onClose}>
              Close
            </Button>
          </CardActions>
        </>
      )}
    </Card>
  );
};

export default ModelInfoCard;